import { Injectable } from '@angular/core';
import { Http } from '@angular/http';
import { Router } from '@angular/router';
import { ApiEvsService } from './ApiEvs.service';

@Injectable()
export class ScoreService extends ApiEvsService {
  constructor(http: Http, router: Router) {
    super(http, router);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/services/Score.service.ts